import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { LoanLimitDoCalculateMutationRequest, LoanLimitDoCalculateMutationResponse, LoanLimitDoCalculate400, LoanLimitDoCalculate401, LoanLimitDoCalculate403, LoanLimitDoCalculate404, LoanLimitDoCalculate410, LoanLimitDoCalculate422, LoanLimitDoCalculate429, LoanLimitDoCalculate500 } from "../types/LoanLimitDoCalculate";

/**
 * @link /api/credit-flow-backend/v1/loan_limit/do_calculate
 */

export function useLoanLimitDoCalculate <TData = LoanLimitDoCalculateMutationResponse, TError = LoanLimitDoCalculate400 | LoanLimitDoCalculate401 | LoanLimitDoCalculate403 | LoanLimitDoCalculate404 | LoanLimitDoCalculate410 | LoanLimitDoCalculate422 | LoanLimitDoCalculate429 | LoanLimitDoCalculate500, TVariables = LoanLimitDoCalculateMutationRequest>(options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "post",
        url: `/api/credit-flow-backend/v1/loan_limit/do_calculate`,
        data,
        
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
